import { DocType } from '../../types';

export const IGNORE_FIX_REQUESTED_FOR_DOC_TYPES = [
  DocType.EQUIPMENT_LOAN_AGREEMENT,
  DocType.SERVICE_LEVEL_AGREEMENT,
  DocType.TAX_FORM_1099,
];

export const P107_NOTIFY_IN_DAYS = 7;
export const COI_NOTIFY_IN_DAYS = 7;
export const COA_NOTIFY_IN_DAYS = 30;
